import "./datetimePickerCustom.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import moment from "moment";
import Datetime from "react-datetime";

import InputCustom from "./inputCustom.react";
import ReactPopover from "react-popover";
let Popover = React.createFactory(ReactPopover);

export default class DateTimePicker extends Component {
  static propTypes = {
    field: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired
  };

  static defaultProps = {};

  constructor(props) {
    super(props);
  }

  updateDate = day => {
    const { actions, isDayPickerVisible, feature, uid, field } = this.props;
    actions.setEntityField(feature, uid, field, day.format("DD.MM.YYYY HH:mm"));
  };

  blur = day => {
    const { actions, isDayPickerVisible, feature, uid, field } = this.props;
    actions.setIsDayPickerVisible(false);
  };

  onInputClick = () => {
    const { actions, entity, isDayPickerVisible } = this.props;
    if (entity.get("uid") === isDayPickerVisible) {
      actions.setIsDayPickerVisible(false);
    } else {
      actions.setIsDayPickerVisible(entity.get("uid"));
    }
  };

  hideDatePicker = () => {
    const { actions } = this.props;
    actions.setIsDayPickerVisible(false);
  };

  render() {
    const {
      day,
      isDayPickerVisible,
      actions,
      entity,
      uid,
      checkField,
      feature,
      params,
      notificationSystem,
      field,
      placeholder
    } = this.props;

    let shouldShowHHMM = true;
    let obj = entity;

    const customProps = {
      actions: actions,
      entity: obj,
      field: ["value"],
      feature: feature,
      uid: uid,
      placeholder: placeholder
    };

    const selectedDay = entity.getIn(field)
      ? moment(entity.getIn(field), "DD.MM.YYYY HH:mm", true).toDate()
      : new Date();
    let datepicker = "";

    let popoverProps = {
      isOpen: isDayPickerVisible,
      preferPlace: "above",
      refreshIntervalMs: 10,
      className: "date-popover",
      body: [
        <Datetime
          locale="pl"
          onChange={this.updateDate}
          onBlur={this.blur}
          input={false}
          defaultValue={selectedDay}
        />
      ]
    };

    datepicker = Popover(
      popoverProps,
      <InputCustom
        className={
          isDayPickerVisible === entity.get("uid") ? (
            "day-picker-input-z-index"
          ) : (
            ""
          )
        }
        field={[field]}
        {...customProps}
        onClick={this.onInputClick}
      />
    );
    return (
      <div>
        {isDayPickerVisible === entity.get("uid") && (
          <div
            className="day-picker-background"
            onClick={this.hideDatePicker}
          />
        )}
        {datepicker}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/datetimePickerCustom.react.js